export default {
  data: function() {
    return {
      copyStrings: {
        titles: {
          profile: 'Profile settings',
          members: 'Users',
          payments: 'Payments',
          statements: 'Statements',
          subscriptions: 'Subscriptions'
        },
        subtitles: {
          profile: 'Profile settings',
          orders: 'These are your orders',
          members: 'Manage your team members',
          payments: 'Manage your cards here',
          statements: 'Download your statements',
          subscriptions: 'Manage your subscription plan',
          report: 'View you company history here'
        }
      }
    }
  }
}
